function MerchantDashboard() {
  return <></>;
}

export default MerchantDashboard;
